import { compressString, decompressString } from "./txtCompressUtil";

// 存储数据到 localStorage，并设置过期时间(单位为 秒)
export function setItemWithExpiration(
  key: string,
  value: any,
  expiration: number
) {
  const item = {
    value: value,
    //计算过期时间戳
    expiration:
      new Date().getTime() +
      (expiration === -1
        ? expiration * 1000 * 999999 // -1, 几乎永不过期
        : expiration * 1000),
  };
  // console.log(key);
  // console.log(getItemWithExpiration("cachedVideoList"));
  localStorage.setItem(compressString(key) || "", compressString(item) || "");
}

export function setNoEncodeItemWithExpiration(
  key: string,
  value: any,
  expiration: number
) {
  const item = {
    value: value,
    //计算过期时间戳
    expiration:
      new Date().getTime() +
      (expiration === -1
        ? expiration * 1000 * 999999 // -1, 几乎永不过期
        : expiration * 1000),
  };
  // console.log(key);
  // console.log(getItemWithExpiration("cachedVideoList"));
  localStorage.setItem(compressString(key) || "", JSON.stringify(item) || "");
}

export function setMapWithExpiration(
  key: string,
  map: any,
  expiration: number
) {
  setItemWithExpiration(key, [...map] as unknown as string, expiration);
}

// export function setObjWithExpiration(
//   key: string,
//   value: any,
//   expiration: number
// ) {
//   const item = {
//     value: value,
//     expiration: new Date().getTime() + expiration * 1000, // 计算过期时间戳
//   };
//   localStorage.setItem(key, JSON.stringify(item));
// }

// 从 localStorage 中获取数据，同时检查是否过期
export function getItemWithExpiration(key: string) {
  const _key = compressString(key);
  if (_key == null || _key === undefined) return null;
  const _value = localStorage.getItem(_key);
  if (_value == null || _value === undefined) return null;
  const item = decompressString(_value) || "";
  if (item && new Date().getTime() < item.expiration) {
    return item.value;
  }
  return null; // 数据过期或不存在
}

export function getNoEncodeItemWithExpiration(key: string) {
  const _key = compressString(key);
  if (_key == null || _key === undefined) return null;
  const _value = localStorage.getItem(_key);
  if (_value == null || _value === undefined) return null;
  const item = JSON.parse(_value || "");
  if (item && new Date().getTime() < item.expiration) {
    return item.value;
  }
  return null; // 数据过期或不存在
}

export function getMapWithExpiration(key: string) {
  const item = JSON.parse(localStorage.getItem(key) as string);
  if (item && new Date().getTime() < item.expiration) {
    return new Map(JSON.parse(item.value));
  }
  return null; // 数据过期或不存在
}

// 从 localStorage 中获取数据，同时检查是否过期
// export function getObjWithExpiration(key: string) {
//   const item = JSON.parse(localStorage.getItem(key) as string);
//   if (item && new Date().getTime() < item.expiration) {
//     return item.value;
//   }
//   return null; // 数据过期或不存在
// }

export function removeItem(key: string) {
  localStorage.removeItem(key);
  return null; // 数据过期或不存在
}

// //========================================
// // =============== LocalStorage ===============
// //========================================
// // 存储数据到 localStorage，并设置过期时间(单位为 秒)
// export function setItemWithExpiration(
//   key: string,
//   value: string,
//   seconds: number
// ) {
//   const item = {
//     value: value,
//     seconds: new Date().getTime() + seconds * 1000, // 计算过期时间戳
//   };
//   localStorage.setItem(key, JSON.stringify(item));
// }

// // export function setObjWithExpiration(
// //   key: string,
// //   value: any,
// //   seconds: number
// // ) {
// //   const item = {
// //     value: value,
// //     seconds: new Date().getTime() + seconds * 1000, // 计算过期时间戳
// //   };
// //   localStorage.setItem(key, JSON.stringify(item));
// // }

// // 从 localStorage 中获取数据，同时检查是否过期
// export function getItemWithExpiration(key: string) {
//   const item = JSON.parse(localStorage.getItem(key) as string);
//   if (item && new Date().getTime() < item.seconds) {
//     return item.value;
//   }
//   return null; // 数据过期或不存在
// }

// // 从 localStorage 中获取数据，同时检查是否过期
// // export function getObjWithExpiration(key: string) {
// //   const item = JSON.parse(localStorage.getItem(key) as string);
// //   if (item && new Date().getTime() < item.seconds) {
// //     return item.value;
// //   }
// //   return null; // 数据过期或不存在
// // }

// export function delItemWithExpiration(key: string) {
//   localStorage.removeItem(key);
// }

// //========================================
// // =============== sessionStorage ===============
// //========================================
// export function setSessionItem(key: string, value: any) {
//   sessionStorage.setItem(key, JSON.stringify(value));
// }

// export function getSessionItem(key: string) {
//   return JSON.parse(sessionStorage.getItem(key) as string);
// }

// export function delSessionItem(key: string) {
//   sessionStorage.removeItem(key);
// }

// //========================================a
// // =============== getSessionOrStorage ===============
// //========================================
// export function getItem(key: string) {
//   return getSessionItem(key) || getItemWithExpiration(key);
// }

// export function delItem(key: string) {
//   delItemWithExpiration(key);
//   delSessionItem(key);
// }
